import SlideFrame from "./_SlideFrame";

export default function SlideSolution() {
  return (
    <SlideFrame tag="02 · The Gap">
      <div className="grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-6">
          <p className="overline mb-6">Our approach</p>
          <h2 className="font-display text-5xl md:text-7xl tracking-tighter leading-[0.9] font-medium">
            End-to-end <em className="italic text-primary">billing & servicing</em> infrastructure, built for modern lenders.
          </h2>
          <p className="mt-8 text-lg text-foreground/75 leading-relaxed max-w-xl">
            One integrated servicing layer — combining infrastructure and execution. You get the
            API-driven backbone <em>and</em> the seasoned operators running it for you.
          </p>
        </div>

        <div className="lg:col-span-6 lg:pl-10 lg:border-l border-foreground/20">
          <div className="grid gap-px bg-foreground/20 border border-foreground/20">
            <div className="bg-background p-8">
              <span className="font-mono-data text-xs text-muted-foreground">01</span>
              <h3 className="font-display text-3xl mt-2">Payments</h3>
              <p className="mt-2 text-sm text-muted-foreground">ACH + card processing built in.</p>
            </div>
            <div className="bg-background p-8">
              <span className="font-mono-data text-xs text-muted-foreground">02</span>
              <h3 className="font-display text-3xl mt-2">Servicing Operations</h3>
              <p className="mt-2 text-sm text-muted-foreground">Operator-led execution at scale — AI-assisted call center, borrower care, collections.</p>
            </div>
            <div className="bg-background p-8 border-t-4 border-t-primary">
              <span className="font-mono-data text-xs text-muted-foreground">03</span>
              <h3 className="font-display text-3xl mt-2">Compliance (optional)</h3>
              <p className="mt-2 text-sm text-muted-foreground">Bundle CompliSun&rsquo;s fractional compliance team + CMS for a deep discount.</p>
            </div>
          </div>
        </div>
      </div>
    </SlideFrame>
  );
}
